import React from "react";
import { SectionWrapper, KPICardWithTrend } from "../../../components/super-admin-dashboard";
import styles from "../SuperAdminDashboardPage.module.css";

const InventoryTab = () => {
  return (
    <SectionWrapper title="Inventory Management">
      <div className={styles.kpiGrid}>
        <KPICardWithTrend
          title="Total Devices"
          value="1,450"
        />
        <KPICardWithTrend
          title="Active Devices"
          value="1,289"
          isPositive={true}
        />
        <KPICardWithTrend
          title="Inactive Devices"
          value="161"
        />
        <KPICardWithTrend
          title="Low Stock Items"
          value="23"
        />
      </div>
    </SectionWrapper>
  );
};

export default InventoryTab;
